export function getCredentialsTypeSnippet(isCharting: boolean, isTimeClock: boolean) {
  if (isCharting && isTimeClock) {
    return "charting and timeclock";
  }

  if (isCharting) {
    return "charting";
  }

  if (isTimeClock) {
    return "timeclock";
  }

  return "";
}
